/*                                     */
/*                                     */
import type { Class } from "type-fest";
import { onLoad } from "@otto-ec/global-resources/dom";
import { addLabels } from "@otto-ec/global-resources/apm";
import { focusDeepWithin } from "@otto-ec/otto-components-utils/utils/focusDeepWithin";

declare global {
  interface Window {
    /**
 *
 *
 */
    __components: {
      /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
      extend: typeof extendCustomElement;
    };
  }
}

/**
 *
 *
 */
export type CustomElement = Class<
  HTMLElement & {
    /**
 *
 */
    connectedCallback(): void;
    /**
 *
 */
    disconnectedCallback(): void;
    /**
 *
 */
    adoptedCallback(): void;
    /**
 *
 *
 *
 *
 */
    attributeChangedCallback(name: string, oldValue: string, newValue: string): void;
  }
> & {
  /**
 *
 */
  readonly observedAttributes: string[];
};

/*                            */
const instanceMap = new Map<string, null[]>();
let instances = 0;
/*                                                        */
function addInstance(tag: string): void {
  if (!instanceMap.has(tag)) {
    instanceMap.set(tag, []);
  }
  const list = instanceMap.get(tag)!;
  list.push(null);
  instances += 1;
}

/*                                                                    */
if (import.meta.env.PROD && !import.meta.env.STORYBOOK) {
  /*                    */
  onLoad.sub(() =>
    /*                                    */
    addLabels(
      /*                                          */
      Object.fromEntries([
        /*                           */
        ["components-count_total", instances],
        /*                          */
        ...[...instanceMap.entries()].map(([tag, list]) => [
          `components-count_${tag.toLowerCase()}`,
          list.length,
        ]),
      ]),
    ),
  );
}

/**
 *
 *
 *
 *
 */
function extendCustomElement({
  formAssociated,
  inputBehavior,
}: {
  /**
 *
 *
 */
  formAssociated?: true;
  /**
 *
 *
 */
  inputBehavior?: true;
} = {}) {
  return (customElement: Class<HTMLElement>): CustomElement => {
    let result = class extends (customElement as CustomElement) {
      connectedCallback(): void {
        /*                               */
        addInstance(this.tagName);
        /*                                                                         */
        return super.connectedCallback();
      }

      /*                                      */
      focus(): void {
        /*                            */
        /*                                                                    */
        /*                                                            */
        /*                                                                                     */
        /*                                                                                                                                                      */
        /*                                                                                                    */
        /*                                                                                                                */
        focusDeepWithin(this);
      }
    };

    if (formAssociated) {
      result = class extends result {
        static formAssociated = true;

        internals: ElementInternals;

        constructor() {
          super();
          this.internals = this.attachInternals() as unknown as ElementInternals;
        }

        get form(): HTMLFormElement | null {
          return this.internals.form;
        }

        set form(value: unknown) {
          if (typeof value === "string") {
            this.setAttribute("form", value);
          }
        }

        formResetCallback(): void {
          /*                                                         */
          /*         */
          this.resetForm?.();
        }
      };
    }

    if (inputBehavior) {
      result = class extends result {
        get defaultValue(): string {
          return this.getAttribute("value") ?? "";
        }

        set defaultValue(value: string) {
          this.setAttribute("value", value);
        }

        get defaultChecked(): boolean {
          return this.hasAttribute("checked");
        }

        set defaultChecked(value: boolean) {
          if (value) {
            this.setAttribute("checked", "");
          } else {
            this.removeAttribute("checked");
          }
        }
      };
    }

    return result;
  };
}

window.__components ??= {} as never;
window.__components.extend = extendCustomElement;
